import { useEffect } from "react";

export const SITE_BASE = "https://www.hrgservice.ch";

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

const metaTag = (attr, key) => () => {
  const m = document.createElement("meta");
  m.setAttribute(attr, key);
  return m;
};

export function usePageMeta(meta) {
  const { title, description, path, jsonLd } = meta || {};
  useEffect(() => {
    if (!title) return;
    const prevTitle = document.title;
    document.title = title;

    const desc = upsert('meta[name="description"]', metaTag("name", "description"));
    const prevDesc = desc.getAttribute("content");
    desc.setAttribute("content", description || "");

    const canonical = upsert('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    });
    canonical.setAttribute("href", SITE_BASE + (path || window.location.pathname));

    upsert('meta[property="og:title"]', metaTag("property", "og:title")).setAttribute("content", title);
    upsert('meta[property="og:description"]', metaTag("property", "og:description")).setAttribute("content", description || "");
    upsert('meta[property="og:url"]', metaTag("property", "og:url")).setAttribute("content", SITE_BASE + (path || window.location.pathname));

    const scripts = [];
    (Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []).forEach((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      scripts.push(s);
    });

    return () => {
      document.title = prevTitle;
      if (prevDesc !== null) desc.setAttribute("content", prevDesc);
      scripts.forEach((s) => s.remove());
    };
  }, [title, description, path]);
}
